import {
    SPORTSMEN_POST_FAILURE,
    SPORTSMEN_POST_REQUEST,
    SPORTSMEN_POST_SUCCESS,
} from 'actions';

const initialState = {
    posting: false,
    hasErrors: false,
};

export const sportsmanPostReducer = (state = initialState, action) => {
    const {type, sportsman} = action;
    switch (type) {
        case SPORTSMEN_POST_SUCCESS: {return {
            ...initialState,
            sportsman,
        }}

        case SPORTSMEN_POST_REQUEST: {return {
            ...initialState,
            posting: true,
        }}

        case SPORTSMEN_POST_FAILURE: {return {
            ...initialState,
            posting: false,
            hasErrors: true,
        }}

        default: {return state}
    }
};
